import { render, staticRenderFns } from "./ButtonYesNo.vue?vue&type=template&id=ddc0c0d0"
import script from "./ButtonYesNo.vue?vue&type=script&lang=js"
export * from "./ButtonYesNo.vue?vue&type=script&lang=js"
import style0 from "./ButtonYesNo.vue?vue&type=style&index=0&id=ddc0c0d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports